module.exports = __webpack_public_path__ + "static/media/video.f95b3d82.webm";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Home/video.webm
// module id = 650
// module chunks = 0